import type { LibraryItem } from '@ideoz/core';
import { ArtifactRow } from './ArtifactRow';

interface ArtifactsListProps {
  artifacts: LibraryItem[];
  deletingId: string | null;
  onOpen: (item: LibraryItem) => void;
  onDelete: (id: string) => void;
}

/** Dumb: the artifacts + prototypes library list. */
export function ArtifactsList({
  artifacts,
  deletingId,
  onOpen,
  onDelete,
}: ArtifactsListProps): JSX.Element {
  return (
    <ul className="divide-y divide-gray-100 dark:divide-gray-700">
      {artifacts.map((item) => (
        <ArtifactRow
          key={`${item.kind ?? 'artifact'}:${item.id}`}
          item={item}
          isDeleting={deletingId === item.id}
          onOpen={() => onOpen(item)}
          onDelete={onDelete}
        />
      ))}
    </ul>
  );
}
